export default function selectedProductReducer(state, { type, payload }) {
    if (!state || state.id !== payload?.product?.id) {
        return state;
    }
    switch (type) {
        case 'deleted': return;
        case 'updated':
            return { ...state, ...payload.changes };
        case 'imageAdded':
            return { ...state, images: state.images.concat(payload.image) };
        case 'imageUpdated':
            return {
                ...state,
                images: state.images.map((image) => {
                    if (image.id === payload.image.id) {
                        return { ...image, ...payload.image };
                    }
                    return image;
                }),
            };
        case 'imageDeleted':
            return {
                ...state,
                images: state.images.filter((image) => image.id !== payload.image.id),
            };
        case 'variantUpdated':
            return {
                ...state,
                variants: state.variants.map((variant) => {
                    if (variant.id !== payload.variant.id) {
                        return variant;
                    }
                    variant = { ...variant, ...payload.changes };
                    if ('price' in payload.changes) {
                        Object.assign(variant, {
                            price: payload.variant.price,
                            presentmentPrices: payload.variant.presentmentPrices,
                        });
                    }
                    return variant;
                }),
            };
        default:
            return state;
    }
}
